export function optional<T>(value: T | null | undefined, defaultValue = undefined): T | undefined {
  return value ?? defaultValue;
}

export default optional;
